import { render, staticRenderFns } from "./CreateHotel.vue?vue&type=template&id=05ea649d&scoped=true&"
import script from "./CreateHotel.vue?vue&type=script&lang=js&"
export * from "./CreateHotel.vue?vue&type=script&lang=js&"
import style0 from "./CreateHotel.vue?vue&type=style&index=0&id=05ea649d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea649d",
  null
  
)

export default component.exports